import Vue from 'vue'

import Vuex from 'vuex'

Vue.use(Vuex)


import common from '@/js/common'
import constants from '@/js/constants'
const store = new Vuex.Store({
    state: {
        curTags: {},
        activeIndex: 1,
        stateTagsList: []
    },
    mutations: {
        checkedTags(state, data) {
            state.curTags = data
            state.activeIndex = data.id
            common.save(constants.selected_tag_key, data)
        },
        setTagsList(state, dataList) {
            state.stateTagsList = dataList
        },
       /**
         * 选择tag标签
         */
        mutationSelectTags(state, data){
            common.save(constants.selected_tag_key, data)
            state.curTags = data
            state.activeIndex = data.id
            let result = false
            for(let i=0; i<state.stateTagsList.length;i++){
                if(state.stateTagsList[i].menuUrl == data.menuUrl){
                    return result = true
                }
            }
            result === false ? state.stateTagsList.push(data) : ''
            common.save(constants.manu_list_key, state.stateTagsList)
        },

        /**
         * 关闭tag标签
         */
        mutationCloseTag(state, data){
            let result = state.stateTagsList.findIndex(item => item.menuUrl === data.menuUrl)
            state.stateTagsList.splice(result, 1)
            common.save(constants.manu_list_key, state.stateTagsList)
        }
    }   
})
export default store


// WEBPACK FOOTER //
// ./src/store/index.js